/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AreaLocalWeather from './AreaLocalWeather';
import DashboardComponentGroupSummary from './DashboardComponentGroupSummary';
import DashboardComponentType from './DashboardComponentType';

/**
* The DashboardComponent model module.
* @module model/DashboardComponent
* @version 2020-12-7
*/
export default class DashboardComponent {
    /**
    * Constructs a new <code>DashboardComponent</code>.
    * @alias module:model/DashboardComponent
    * @class
    * @param type {module:model/DashboardComponentType} 
    * @param width {Number} 
    * @param height {Number} 
    * @param title {String} 
    */

    constructor(type, width, height, title) {
        
        
        this['type'] = type;
        this['width'] = width;
        this['height'] = height;
        this['title'] = title;
        
    }

    /**
    * Constructs a <code>DashboardComponent</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/DashboardComponent} obj Optional instance to populate.
    * @return {module:model/DashboardComponent} The populated <code>DashboardComponent</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DashboardComponent();
                        
            
            if (data.hasOwnProperty('lastUpdateDate')) {
                obj['lastUpdateDate'] = ApiClient.convertToType(data['lastUpdateDate'], 'Number');
            }
            if (data.hasOwnProperty('areas')) {
                obj['areas'] = ApiClient.convertToType(data['areas'], [AreaLocalWeather]);
            }
            if (data.hasOwnProperty('weekly')) {
                obj['weekly'] = ApiClient.convertToType(data['weekly'], [DashboardComponentGroupSummary]);
            }
            if (data.hasOwnProperty('monthly')) {
                obj['monthly'] = ApiClient.convertToType(data['monthly'], [DashboardComponentGroupSummary]);
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = DashboardComponentType.constructFromObject(data['type']);
            }
            if (data.hasOwnProperty('width')) {
                obj['width'] = ApiClient.convertToType(data['width'], 'Number');
            }
            if (data.hasOwnProperty('height')) {
                obj['height'] = ApiClient.convertToType(data['height'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {Number} lastUpdateDate
    */
    'lastUpdateDate' = undefined;
    /**
    * @member {Array.<module:model/AreaLocalWeather>} areas
    */
    'areas' = undefined;
    /**
    * @member {Array.<module:model/DashboardComponentGroupSummary>} weekly
    */
    'weekly' = undefined;
    /**
    * @member {Array.<module:model/DashboardComponentGroupSummary>} monthly
    */
    'monthly' = undefined;
    /**
    * @member {module:model/DashboardComponentType} type
    */
    'type' = undefined;
    /**
    * @member {Number} width
    */
    'width' = undefined;
    /**
    * @member {Number} height
    */
    'height' = undefined;
    /**
    * @member {String} title
    */
    'title' = undefined;




}
